
<template>
  <div  >
   
    <div class="home">
   
        <!-- <div class="bg-overlay"></div> -->
       <div>
         <div class="container " >
           <div  class="button-group " style="position: absolute;top:630px; z-index: 100;">
            <!-- <div style="position: absolute;left:0" >
              <div id="buttonddd"  >
                <div  id="follower" class="hover-effect"   ></div> 
              </div>
            </div> -->

            <div class="flx-center " id="follower-button"  >

              <el-button
               v-for="(item, index) in buttons"
               :key="index"
              :class="{ 'active': activeIndex === index,[`buttonChange${index + 1}`]: true}"
               class="flx-center "
               @click="setActive(item,index)"
             >
               <div class="btn-text" 
               style=""  
               @mouseover="moveFollower($event, index)"
           
                >
           
                  <img :src="item.icon" alt="" class="button-icon" />
                  <span>{{ item.label }}</span>
               

              </div>
             </el-button>
             <div  id="follower" class="hover-effect"   ></div> 

            </div>
           </div>
          
        </div>
        <div class="container"  style="margin-top: 100px;margin-bottom: 40px;" >
            <div class="flx-justify-around" style="width: 100%;">
              
              <img :src="$ossUrl +'images/home/internetImages/title1.png'" alt="">
               <img :src="$ossUrl+'images/home/internetImages/title2.png'" alt="">
               <img :src="$ossUrl+'images/home/internetImages/title3.png'" alt="">
               <img :src="$ossUrl+'images/home/internetImages/title4.png'" alt="">
               <img :src="$ossUrl+'images/home/internetImages/title5.png'" alt="">
               </div>
           </div>
      
          </div>
           <div class="service-text-bg" style="">
            <div ref="section1">
              <div class="service-text" style="padding-top: 70px;margin-bottom: 70px;">
                  What <div class="service">service</div> do I provide<i></i>
                </div>
                <div class="container" style="display: -webkit-box;" >
                  <div
                         v-for="(card, index) in cards"
                         :key="index"
                         :class="['cardBox', { 'card-active': activeCardIndex === index }]"
                         @click="activeCardIndex = index"
                       >
                         <div class="card-icon">
                           <!-- 这里放置图标，可以使用图片或图标库 -->
                           <img :src="card.icon" alt="icon" />
                         </div>
                         <div class="card-title">{{ card.title }}</div>
                         <div class="card-description">
                          <div>{{ card.desc_1 }}</div>
                          <div>{{ card.desc_2 }}</div>
                        </div>

                       </div>
                </div>
            </div>
          <div class="container " ref="section2" style="margin-top: 60px;display: flex;">
                <div class="hotLinePadding" >
            <div class="hotLine">Hot Line</div>
            <div class="toggle-buttons" style="width: 600px;">
                  <el-row style="position: relative;z-index: 999;width: 100%;">
                    <el-col 
                      :span="12"
                      v-for="(button, index) in buttonTogs"
                      :key="index"
                    >          
                     <div
                     @click="activeTogIndex = index"
                     :class="['buttonTogsBox', { 'toggle-active': activeTogIndex === index}]"
                     >
                        
                        <span class="activeTogSpan">
                          <img v-if="button.icon" style="width: 20px;height: 20px;" :src="button.icon" alt="icon" />
                          {{ button.text }}
                        </span>

                      </div>
                      
                    </el-col>
                  </el-row>
            </div>
                </div>
                <!-- 地球 -->
                <div style="">
                  <Earth  />
                </div>
          </div>
            <div  class="container card card-padding" ref="section3" style="box-shadow: 0px 4px 47.3px 0px #F6F6F6;z-index:2;">
                <el-row>
                  <el-col :span="6">
                    <div class="statistic-item statistic-item-padding">
                       <div class="number">{{num1}}+</div>
                       <div class="label">公司员工</div>
                     </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="statistic-item statistic-item-padding">
                       <div class="number">{{num2}}+</div>
                       <div class="label">全球分公司</div>
                     </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="statistic-item statistic-item-padding">
                       <div class="number">{{num3}}W <i>M²</i></div>
                       <div class="label">国内仓储面积</div>
                     </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="statistic-item statistic-item-padding">
                      <div class="number">{{num4}}W <i>M²</i></div>
                       <div class="label">自营海外仓面积</div>
                     </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="statistic-item">
                       <div class="number">{{num5}}+</div>
                       <div class="label">自营线路</div>
                     </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="statistic-item">
                      <div class="number">{{num6}}W <i>T</i></div>
                       <div class="label">空派承运量（年）</div>
                     </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="statistic-item">
                       <div class="number">{{num7}}W <i>Teu</i></div>
                       <div class="label">集装箱派送量（年）</div>
                     </div>
                  </el-col>
                   <el-col :span="6">
                    <div class="statistic-item">
                       <div class="number">{{num8}}车</div>
                       <div class="label">卡航派送量（年）</div>
                     </div>
                  </el-col>
                </el-row>
            </div>
        </div> 

        <div class="container card " >
          <div ref="section4">
               <div class="service-text" style="padding-top: 50px;margin-bottom: 70px;">
                <div >News</div><i class="serviceNews"></i>
              </div>
               <div class="flx">
                   <div >
                     <img class="newsBig" :src="$ossUrl+'images/home/news.jpg'" alt="">
                   </div>
                   <div>
                     <div class="newsSmallTag">
                    <div 
                    v-for="(item, index) in news"
                     :key="index"
                     :class="['newsSmall', { 'new-active': newIndex === index }]"
                     @click="setNewsActive(item,index)"
                    >
                    <div class="smallTitle show-ellipsis ">{{ item.title }}
                      <img :src="$ossUrl+'images/home/iconImages/right.png'" alt="">
                    </div>
                    <div class="smallContent show-ellipsis ">{{ item.content }}
                    </div>

                    </div>
                     </div>
                   </div>
            </div>
          </div>
        
        </div>
        <div style="position: relative;"  ref="section5">
          <div class="container">
           <div class=" flx-center" style="margin-top: 69px;">
               <div class="viewBox" @click="$router.push({name:'news'})">View More</div>
            </div>
         
        </div>
        <div class="container flx-align ">
              <div @click="$router.push({name:'news'})" class="NewsTrends flx-only-justify-between " style="margin-top: 69px;padding: 45px 30px 58px 35px;">
                <div class="flx-column-justify-around ">
                  <div class="NewsTrendsTitle">新闻动态</div>
                  <!-- <div class="NewsTrendsTag">Tag</div> -->
                  <div class="NewsTrendsDetail">See Detail Project</div>
                </div>
                <div>
                    <img style="width: 269px;" :src="$ossUrl+'images/home/NewsTrends1.png'" alt="">
                </div>
            </div>
            <div @click="$router.push({name:'news'})" class="NewsTrends " style="margin-top: 69px;padding: 45px 42px 58px 35px;background-color:#307ef3 ;">
                <div class="NewsTrendsImage">
                    <img  style="width: 289px;" :src="$ossUrl+'images/home/NewsTrends2.png'" alt="">
                </div>
                <div></div>
                <div class="flx-column-justify-around " style="margin-right: 190px;height: 200px;">
                  <div class="NewsTrendsTitle">干货分享</div>
                  <!-- <div class="NewsTrendsTag">Tag</div> -->
                  <div class="NewsTrendsDetail">See Detail Project</div>
                </div>
            </div>
            </div>
        <div class=" service-text-bg "  style="margin-top: 80px;" >
          <div class="container" ref="section6">
            <div class="service-text" style="padding-top: 20px;margin-bottom: 40px;">
               <div >Question</div><i class="serviceNews"></i>
            </div>
          <div class="commonUI">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="发货前" name="first">
                <BeforeDelivery :activeName="activeName"></BeforeDelivery>
              </el-tab-pane>
              <el-tab-pane label="国内报关" name="second">
                <DomesticCustomsDeclaration :activeName="activeName"></DomesticCustomsDeclaration>
              </el-tab-pane>
              <el-tab-pane label="干线运输" name="third">
                <TrunkTransport :activeName="activeName"></TrunkTransport>
              </el-tab-pane>
              <el-tab-pane label="国外清关" name="fourth">
                <ForeignTransport :activeName="activeName"></ForeignTransport>
              </el-tab-pane>
              <el-tab-pane label="妥投签收" name="five">
                <DulyReceived :activeName="activeName"></DulyReceived>
              </el-tab-pane>
              <el-tab-pane label="本地增值" name="six">
                <LocalAdded :activeName="activeName"></LocalAdded>
              </el-tab-pane>
              <el-tab-pane label="亚马逊全球开店" name="seven">
                <Amazon :activeName="activeName"></Amazon>
              </el-tab-pane>
            </el-tabs>
          </div>
          </div>
        
        </div>
        </div>
      <!--END HOME-->


      <!-- 
      <Services />
      <About />
      <Pricing />
      <Testimonial />
      <GetStarted />
      <Blog />
      <Contact />
 
      <Switcher /> -->
    </div>
  </div>
</template>
<script>
import Earth from "@/view/newsHome/homeComponents/earth.vue";
import Amazon from "@/view/newsHome/homeComponents/Amazon";
import BeforeDelivery from "@/view/newsHome/homeComponents/beforeDelivery";
import DulyReceived  from "@/view/newsHome/homeComponents/dulyReceived";
import LocalAdded from "@/view/newsHome/homeComponents/LocalAdded";
import ForeignTransport from "@/view/newsHome/homeComponents/foreignTransport";
import DomesticCustomsDeclaration from "@/view/newsHome/homeComponents/domesticCustomsDeclaration";
import TrunkTransport from "@/view/newsHome/homeComponents/trunkTransport";
import {ceshi} from '@/api/home.js'

// import Switcher from "@/view/home/homeComponents/switcher";

/**
 * Index-1 component
 */

export default {
  components: {
    Earth,
    Amazon,
    BeforeDelivery,
    DulyReceived ,
    LocalAdded,
    ForeignTransport,
    DomesticCustomsDeclaration,
    TrunkTransport,
    // Switcher
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  created() {
   
    this.toTotal();
    let paramObj = {
        uid: "123456",
      };
      // ceshi(paramObj).then((data) => {
      //   console.log(data);
      // });
      // console.log(localStorage.getItem("newsIndex"),'newsIndex');
      // this.newIndex = +localStorage.getItem("newsIndex") || 0;
  },
  data() {
    return {
      event:'',
      index:null,
      hoverActive: false,
      translateX_hover:0,
      num1:950,
      num2:15,
      num3:0,
      num4:0,
      num5:50,
      num6:0.5,
      num7:0.6,
      num8:1770,
      activeName: 'first', //tabs页切换
      activeIndex: 0, // 默认选中第一个按钮
      buttons: [
        { label: '海运下单',icon: this.$ossUrl+'images/home/iconImages/Sea.png',transportMode:'OCEAN' },
        { label: '空运下单',icon: this.$ossUrl+'images/home/iconImages/Plane.png',transportMode:'AIR' },
        { label: '铁运下单',icon: this.$ossUrl+'images/home/iconImages/Railroad.png',transportMode:'RAIL' },
        { label: '拖车下单',icon: this.$ossUrl+'images/home/iconImages/Delivery.png',transportMode:'ROAD' }
      ],
      activeCardIndex: 0,
      cards: [
        { icon: this.$ossUrl+'images/home/iconImages/Plane-1.png', title: '美通空运', desc_1: '渠道成熟，线路众多；',desc_2: '清关高效，尾程灵活派送；' },
        { icon: this.$ossUrl+'images/home/iconImages/Sea-1.png', title: '美通海运', desc_1: '渠道多样，与各大船东合作；',desc_2: '时效稳定，安全无忧；' },
        { icon: this.$ossUrl+'images/home/iconImages/Shipment.png', title: '美通卡航', desc_1: '零担拼车，自有车队尾程派送；' ,desc_2: 'DG货物发车频率高，运输安全；'},
        { icon: this.$ossUrl+'images/home/iconImages/Warehouse.png', title: '海外仓', desc_1: '8国自营海外仓；',desc_2: '提供多种服务；' },
      ],
      activeTogIndex:0,
      buttonTogs: [
        { text: '美国空运专线',   icon:this.$ossUrl+'images/business/overSea/US.png'},
        { text: '欧盟空运专线',   icon:this.$ossUrl+'images/business/overSea/OM.jpg'},
        { text: '英国空运专线',   icon:this.$ossUrl+'images/business/overSea/GB.png'},
        { text: '加拿大空运专线', icon:this.$ossUrl+'images/business/overSea/CA.png'},
        { text: '日本空运专线',   icon:this.$ossUrl+'images/business/overSea/JP.png'},
        { text: '特殊产品及DG货物'},
      ],
      newIndex:0,
      news: [
        { id:'1', title: '一波接一波，海运涨价潮为何停不下来？',content:"近期，多家船司发布运费上涨公告，欧美40HQ的海运费从3月初的3000美元左右暴涨到现在的5000美元上下。而这波涨价潮一波接一波来袭，主要原因是中东地缘冲突。此外，国际政策、市场货量变化、船司签约季等因素也对海运费上涨产生了一定影响。"},
        { id:'2',title: '喜讯丨美通连续斩获4项荣誉奖项！',content:"近日， 美通先后荣获“FBA物流十强企业”、“拉美出海2023年度优质服务企业”、“2023年度坂田街道经济发展卓越贡献奖”、“网商领军会员企业”等4项大奖，标志着美通在跨境电商物流服务领域的卓越表现得到高度认可，也是对美通始终坚持高效运营、优化业务流程以及提升客户满意度等方面的肯定。"},
        { id:'3',title: '亚马逊合规化丨如何填好IEN编号？变体违规了怎么办？',content:"亚马逊近年来针对平台的合规化运营出台了一系列规则。近期，新的欧洲贸易合规要求——仓储服务运营商尽职调查方案（FHDDS），要求亚马逊英国站卖家及时完成合规，6月30日起IEN未合规将可能受限。而同时一批卖家收到变体不合规导致账户停用的通知，并下架了相关listing。"},
        { id:'4',title: '重磅！美通正式成为亚马逊TSPN服务商',content:"2024年3月，美通正式成为亚马逊TSPN(Transparency Service Provider Network)服务商！"},

      ],
      sections: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
      ],
    };
  },
  methods: {
    moveFollower(event, index) {
      // console.log(event, index);
    const follower = document.getElementById('follower');
    const button = event.currentTarget;  // 当前hover的按钮
    // console.log(event,'button')
    const rect = button.getBoundingClientRect();
      // console.log(index,'rect')
    // 计算新位置，使 follower 居中于按钮
    const followerX = rect.left  - button.offsetWidth/2 - follower.offsetWidth*2-120;
      if(index==0){
        follower.style.transform = `translate(-469px)`;
      }else if(index==1){
        follower.style.transform = `translate(-157px)`;
      }
      else if(index==2){
        follower.style.transform = `translate(157px)`;
      }else {
        follower.style.transform = `translate(469px)`;
      }
    // 更新follower位置
  },
    handleScroll() {
      this.sections.forEach(section => {
      // console.log(section,'section')

        const refName = `section${section}`;
        const element = this.$refs[refName];
        element.style.opacity = '0';
        if (element && this.isElementInViewport(element)) {

        setTimeout(() => {
          element.classList.add('slide-up-enter-active');
           element.style.opacity = '1';

        }, 350);
      }

      });
    },
    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top <= (document.documentElement.clientHeight / 1.2  )
      );
    },
    setNewsActive(item,index) {
      console.log(item,index);
      // this.newIndex = index;
      // localStorage.setItem('newsIndex',index);
      this.$router.push({
        name: 'newsDetail',
        query:{
          id:item.id
        }
      });
    },
    setActive(item,index) {
      
      console.log(item.transportMode,index);
      this.activeIndex = index;
      setTimeout(() => {
      // window.location.href=  `http://47.119.163.201/#/home/index?companyType=company&companyTransportMode=${item.transportMode}`
      // window.location.href=  `http://192.168.10.54:9081/#/home/index?companyType=company&companyTransportMode=${item.transportMode}`
      window.location.href=  `http://56carrier.com:80/#/home/index?companyType=company&companyTransportMode=${item.transportMode}`

      }, 200);

    },
    toggleMenu() {
      document.getElementById("navbarCollapse").classList.toggle("show");
    },
    // 点击tabs
    handleClick(tab, event) {
        console.log(tab, event);
    },
    // 倒计时
    toTotal() {
      this.timer1 = setInterval(() => {
        if (this.num1 === 1000) {
          clearTimeout(this.timer1);
        } else {
          this.num1++;
        }
      }, 50);
      this.timer2 = setInterval(() => {
        if (this.num2 === 40) {
          clearTimeout(this.timer2);
        } else {
          this.num2++;
        }
      }, 80);
      this.timer3 = setInterval(() => {
        if (this.num3 === 6) {
          clearTimeout(this.timer3);
        } else {
          this.num3 ++;
        }
      }, 300);
      this.timer4 = setInterval(() => {
        if (this.num4 === 5) {
          clearTimeout(this.timer4);
        } else {
          this.num4++;
        }
      }, 280);
      this.timer5 = setInterval(() => {
        if (this.num5 === 80) {
          clearTimeout(this.timer5);
        } else {
          this.num5++;
        }
      }, 80);
      this.timer6 = setInterval(() => {
        if (this.num6 === 2.5) {
          clearTimeout(this.timer6);
        } else {
          this.num6++;
        }
      }, 500);
      this.timer7 = setInterval(() => {
        if (this.num7 === 2.6) {
          clearTimeout(this.timer7);
        } else {
          this.num7++;
        }
      }, 500);
      this.timer8 = setInterval(() => {
        if (this.num8 === 1800) {
          clearTimeout(this.timer8);
        } else {
          this.num8++;
        }
      }, 80);
    },
  }
  
};
</script>
<style src="./index.css" scoped>






</style>